const LOGGED_IN_USER = "logged-in";
const NON_LOGGED_IN_USER = "not-logged-in";
const WEB_SHOP = "react_web_shop";
const NON_EMPTY_SEARCH = "non-empty-search";

export { LOGGED_IN_USER, NON_LOGGED_IN_USER, WEB_SHOP, NON_EMPTY_SEARCH };
